import http from "./httpService";

const LOGIN_ENDPOINT = "/user-mgmt/admin/login";

/**
 * Login user.
 *
 * @param {string} email User email.
 * @param {string} password User password.
 *
 * @return {Promise<Object>} The login response.
 */
export const login = async (email, password) => {
  const { data } = await http.post(LOGIN_ENDPOINT, { email, password });

  console.log("Login response data:", data);
  if (data.errorCode !== 0) {
    throw new Error(data.message || "Login failed");
  }

  if (!data.data || !data.data.token) {
    console.error("API response is missing data or token!", data);
    throw new Error("Invalid login response");
  }

  return data.data;
};
